	export enum SalesOrderInventoryStatusEnum {
		PendingOrder = 1,
		Ordered = 2,
		Received = 3,
		OrderedAndPendingOrder = 4,
		ReturnedToStock = 5,
		ReturnedToManufacturer = 6,
		Returned = 7,
		RepairInShop = 8,
		RepairOutOfShop = 9,
		Repaired = 10,
		DeliveredToPatient = 11
	}
